export const capitalizeFirstLetter = (string: string): string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export function slugify(value: string): string {
  return (
    value
      // Replace special characters
      .replace(/[\s~`!@#$%^&*()\-_+=[\]{}|\\;:"'<>,.?/]+/g, '-')
      // Remove continuous separators
      .replace(/-{2,}/g, '-')
      // Remove prefixing and trailing separators
      .replace(/^-+|-+$/g, '')
      // ensure it doesn't start with a number (like #123)
      .replace(/^(\d)/, '_$1')
      // lowercase
      .toLowerCase()
  );
}

export function removeAccents(string: string): string {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function splitAtLastSpace(str: string) {
  const lastSpaceIndex = str.lastIndexOf(' ');
  const firstPart = str.substring(0, lastSpaceIndex);
  const secondPart = str.substring(lastSpaceIndex + 1);

  return [firstPart, secondPart];
}

export const isNonEmptyString = (value: unknown): value is string => {
  return typeof value === 'string' && value.trim() !== '';
};

// Zero-width, bidi-control and other invisible Unicode characters that can
// sneak into SKUs pasted from watermarked sources and silently break exact
// string matches against Saleor / Algolia / OrderApp.
// U+1D173–U+1D17A are the Musical Symbol Begin/End beam characters that
// Contentful's live-preview SDK uses to steganographically encode hex digits
// 8–f (entry/field IDs are UUIDs so these always appear). Requires the `u`
// flag since they are above U+FFFF.
const INVISIBLE_UNICODE_RE =
  /[\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFEFF\u{1D173}-\u{1D17A}]/gu;

export function stripInvisibleUnicode<T extends string | null | undefined>(
  value: T,
): T {
  return (
    typeof value === 'string'
      ? value.replace(INVISIBLE_UNICODE_RE, '').trim()
      : value
  ) as T;
}
